import { Checkbox, CheckboxProps } from '@mui/material';
import { DataCellProps } from '../types';
import { FC } from 'react';

export const TeamMemberCheckboxCell: FC<DataCellProps> = ({
  member: { account_id: accountId },
  _customRowProps: { selectTeamMember, selectedMemberIds },
}) => {
  const handleCheckboxClick: CheckboxProps['onClick'] = (event) => {
    event.stopPropagation();
    selectTeamMember({ accountId });
  };

  return (
    <div>
      <Checkbox checked={selectedMemberIds.has(accountId)} onClick={handleCheckboxClick} />
    </div>
  );
};
